import React, {useEffect} from 'react'

type Props = {
  children: React.ReactNode
}

const ReloadAlert: React.FC<Props> = ({children}) => {
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault()
      const confirmationMessage = 'Are you sure you want to leave? Your changes may not be saved.'
      event.returnValue = confirmationMessage
      if (window.confirm(confirmationMessage)) {
        event.returnValue = undefined
      } else {
        window.close()
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return <>{children}</>
}

export default ReloadAlert
